import React from "react";

import Box from "@mui/material/Box";

const TitledBox = ({ title, color, sx, children }) => {
	return (
		<Box
			sx={{
				...sx,
				position: "relative",
				border: `1px solid ${color}`,

				"&::after": {
					content: `"${title}"`,
					position: "absolute",
					top: "-12px",
					left: "20px",
					color: "#fff",
					background: `${color}`,
					height: "24px",
					width: "auto",
					display: "flex",
					alignItems: "center",
					padding: "0 10px",
					whiteSpace: "nowrap",
					fontSize: "14px",
				},
			}}
		>
			{children}
		</Box>
	);
};

export default TitledBox;
